"use client";

import { datadogRum } from "@datadog/browser-rum";

datadogRum.init({
  applicationId: process.env.NEXT_PUBLIC_DD_APP_ID || "",
  clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN || "",
  defaultPrivacyLevel: "mask-user-input",
  env: process.env.NODE_ENV,
  service: process.env.NEXT_PUBLIC_DD_SERVICE,
  sessionReplaySampleRate: 1,
  sessionSampleRate: 100,
  site: "datadoghq.com",
  trackUserInteractions: true,
  version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side

  datadogRum.onReady(() => {
    if (!process.env.NEXT_PUBLIC_DD_APP_ID) {
      console.error("NEXT_PUBLIC_DD_APP_ID must be defined.");
    }

    if (!process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
      console.error("NEXT_PUBLIC_DD_CLIENT_TOKEN must be defined.");
    }
  });

  return null;
}
